module.exports = __webpack_public_path__ + "img/zx15.a01a172d.png";